var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 35.5559V3.05587M42.3 17.1667L27.5 2.5L12.7001 17.1667",
    stroke: "#00B3FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 37.167V42.0559C53.5 44.6492 52.4605 47.1362 50.6101 48.9699C48.7598 50.8036 46.2501 51.8337 43.6333 51.8337H12.3667C9.74986 51.8337 7.24024 50.8036 5.38988 48.9699C3.53952 47.1362 2.5 44.6492 2.5 42.0559V37.167",
    stroke: "#00B3FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconRound);
export default __webpack_public_path__ + "static/media/upload-icon-round.74b3749937de53237926d2fcf06007b2.svg";
export { ForwardRef as ReactComponent };